// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__1FqkO","content":"layout_content__1DK-Z","sidebarActive":"layout_sidebarActive__3ovvr","badge":"layout_badge__2lhUI"};